'use strict';

import React from 'react';

const Confirmation = ({ msg }) => {

  return (
    <div className="Confirmation">
      <i className="fa-thin fa-circle-check fa-3x onsched-success-color"></i>
      <h1>Thank you!</h1>
      <p>{ msg }</p>
    </div>
  )
};

export default Confirmation;
